module.exports = __webpack_public_path__ + "img/foot_course_content.466619bd.png";